
var $body = $("body");
var $cartToggle = $(".cart");
var $cartContainer = $("header").find("#cart-container");
var $addToCart = $(".add-to-cart");
var $addToCartQuantity = $(".add-to-cart-quantity");

var $closeCart = $cartContainer.find(".close-slide");
$closeCart.on("click", function () {
    "use strict";
    if ($cartContainer.hasClass("show")) {
        $cartContainer.removeClass("show");
    }
    if ($body.hasClass("overlay")) {
        $body.removeClass("overlay");
    }
});

var $accordionToggle = $("#accordionDelivery .card .card-header").find(".toggle");
var $radioButtonCheck = $accordionToggle.find(".radio-button > .radio-inner");
$accordionToggle.on("click", function () {
    "use strict";
    var $radioButton = $(this).find(".radio-inner");
    $radioButtonCheck.removeClass("checked");
    if ($radioButtonCheck.hasClass("checked")) {
        $radioButtonCheck.removeClass("checked");
    } else {
        $radioButton.addClass("checked");
    }
});

var $accordionPaymentToggle = $("#accordionPayment .card .card-header").find(".toggle");
var $radioButtonCheckPayment = $accordionPaymentToggle.find(".radio-button > .radio-inner");
$accordionPaymentToggle.on("click", function () {
    "use strict";
    var $radioButton = $(this).find(".radio-inner");
    $radioButtonCheckPayment.removeClass("checked");
    if ($radioButtonCheckPayment.hasClass("checked")) {
        $radioButtonCheckPayment.removeClass("checked");
    } else {
        $radioButton.addClass("checked");
    }
});

var $paymentToggle = $("#checkout").find(".payment-toggle");
var $paymentContainer = $("#checkout").find("#order-details");
$paymentToggle.on("click", function () {
    $(this).toggleClass("toggle");
    $paymentContainer.toggleClass("expanded");
    $body.toggleClass("overflow-hidden");
});

(function () {
    'use strict';
    window.addEventListener('load', function () {
        var forms = document.getElementsByClassName('needs-validation');
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    $(form).addClass('has-errors');
                } else {
                    $(form).removeClass('has-errors');
                    $(form).addClass('submitting');
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

var Cart = function (container, type) {
    this._body = $("body");
    this._addButton = $(".add-to-cart-button");
    this._addQuantityInput = $(".add-to-cart-quantity");
    this._addOptions = $(".product-options");
    this._cartContainer = container;
    this._type = type;
    this.initialize();
};
Cart.prototype = {
    _body: null,
    _addButton: null,
    _addOptions: null,
    _addQuantityInput: null,
    _changeTimeout: null,
    _changeRequest: null,
    _cartContainer: null,
    _type: null,
    initialize: function () {

        var self = this;

        if (this._type == 'full') {
            $.get('/cart/cart?type=full', {}, function (html) {
                self.openWithHTML(html);
            });
        }
        if (this._type == 'side') {
            this._addButton.on('click', function () {
                var options = [];

                if (self._addOptions.length > 0) {
                    var valid = true;
                    self._addOptions.each(function () {
                        if ($(this).find('input:checked').val() != null) {
                            options.push($(this).find('input:checked').val());
                        } else if ($(this).find('input.current-size').length > 0) {
                            options.push($(this).find('input.current-size').val());
                        } else {
                            $(this).addClass('error');
                            valid = false;
                        }
                    });

                    if (!valid) {
                        return false;
                    }
                }

                var button = $(this);

                var cartData = {
                    id: $(this).data('id'),
                    qty: self._addQuantityInput.length == 0 ? 1 : self._addQuantityInput.val(),
                    options: options,
                    mobile: button.hasClass('add-to-cart-mobile')
                };
                var maxOrderAmount = button.closest(".add-to-cart-container").find(".btn-plus").data("max-order-amount");
                if (parseFloat(maxOrderAmount)) {
                    cartData.max_order_amount = parseFloat(maxOrderAmount);
                }

                $.post('/cart/add?locale=sl_SI', cartData).done(function (html) {
                    $('.max-order-amount-alert').removeClass('show');
                    if (button.hasClass('add-to-cart-mobile')) {
                        $("#addToCartPopup").html(html).modal();
                        getStatus();
                    } else {
                        self.openWithHTML(html);
                        getStatus();
                    }

                }).fail(function (xhr, status, error) {
                    $('.max-order-amount-alert').html(error).addClass('show');
                });

                return false;
            });

            // this._addOptions.find('input').on('click', function () {
            //     $(this).parents('.product-options.error').removeClass('error');
            // });

            // self._body.on('click', '.add-to-cart-list', function () {

            //     var button = $(this);

            //     $.post('/cart/add', {
            //         id: $(this).parents('.product').data('product'),
            //         qty: 1,
            //         options: []
            //     }, function (html) {

            //         if (button.hasClass('add-to-cart-mobile')) {
            //             $("#addToCartPopup").modal();
            //         } else {
            //             self.openWithHTML(html);
            //         }

            //     });

            //     return false;
            // });

            self._body.find('.side-cart-overlay').on('click', function () {
                self._body.removeClass('overlay');
                self._cartContainer.removeClass('show');
            });
        }
    },
    openWithHTML: function (html) {

        getConfiguratorItems();

        var self = this;

        if (this._type == 'side') {
            self._body.addClass('overlay');
        }
        self._cartContainer.html(html).addClass('show');

        self._cartContainer.find('.close-slide').on('click', function () {
            self._body.removeClass('overlay');
            self._cartContainer.removeClass('show');
        });

        self._cartContainer.find('.remove-button').on('click', function () {
            var product = $(this).parents('.product');
            var qty = product.find('.qty');

            var options = product.data('options') == '' ? [] : product.data('options').split(';');

            self.change('remove', {
                id: product.data('id'),
                options: options
            },
                $(this));

            return false;

        });

        self._cartContainer.find('.btn-plus').on('click', function () {
            var product = $(this).parents('.product');
            var qty = product.find('.qty');

            var maxOrderAmount = $(this).data("max-order-amount");
            if (parseInt(maxOrderAmount) <= parseInt(qty.val())) {
                $(this).closest('.quantity').find('.max-order-amount-alert').html('Največja količina naročanja je ' + parseInt(maxOrderAmount) + '.').addClass('show');
                return;
            } else {
                $(this).closest('.quantity').find('.max-order-amount-alert').removeClass('show');
            }

            qty.val(parseInt(qty.val()) + 1).trigger('blur');
        });

        self._cartContainer.find('.btn-minus').on('click', function () {
            $(this).closest('.quantity').find('.max-order-amount-alert').removeClass('show');
            var product = $(this).parents('.product');
            var qty = product.find('.qty');

            qty.val(parseInt(qty.val() - 1)).trigger('blur');

            return false;
        });

        self._cartContainer.find('.qty').on('blur', function () {
            var product = $(this).parents('.product');

            var options = product.data('options') == '' ? [] : product.data('options').split(';');

            self.change('qty', {
                id: product.data('id'),
                qty: product.find('.qty').val(),
                options: options
            }, $(this));

            return false;
        });

        if (!self.executed) {
            self.executed = true;
            var contentIds = [];
            var contents = [];
            var ecommerceContents = [];
            $(".cartfull-products-list .product").each(function () {
                contentIds.push($(this).data("productcode"));
                contents.push({ 'id': $(this).data("productcode"), 'quantity': $(this).data("quantity") });
                //Ecommerce
                ecommerceContents.push({
                    'item_id': $(this).data("productcode"),
                    'item_name': $(this).data("name"),
                    'discount': $(this).data("discount"),
                    'price': $(this).data("price"),
                    'quantity': $(this).data("quantity")
                });
            });
        }
    },
    change: function (action, data, element) {
        var self = this;

        if (self._changeRequest != null) {
            self._changeRequest.abort();
        }
        if (self._changeTimeout != null) {
            clearTimeout(self._changeTimeout);
        }

        self._changeTimeout = setTimeout(function () {
            self._cartContainer.find('.cart-overlay').show();
            $(".quantity-loader").show();

            self._changeRequest = $.post('/cart/' + action + '?type=' + self._type, data, function (html) {
                self.openWithHTML(html);

                getStatus();

                $(".quantity-loader").hide();
            });
        }, 600);
    }
};

var fullCartPlaceholder = $(".full-cart-placeholder");
var sideCartPlaceholder = $(".side-cart-placeholder");
if (fullCartPlaceholder.length > 0) {
    //fullCartPlaceholder.prepend('<div class="list-loader"><div class="inner"></div></div>');
    new Cart(fullCartPlaceholder, 'full');
} else {
    new Cart($(".side-cart-placeholder"), 'side');
}

getStatus();

function getStatus() {
    $.get('/cart/status', function (response) {
        var data = JSON.parse(response);
        if (data.cart > 0) {
            $(".icon-cart-full").addClass("active");
        } else {
            $(".icon-cart-full").removeClass("active");
        }
        $(".icon-cart-full .count").show().html(data.cart > 0 ? data.cart : '');

        if (data.user != null) {
            $(".user-login .icon-user").addClass("active");
            $(".user-login .icon-user").attr("title", "Moj profil");
        } else {
            $(".user-login .icon-user").removeClass("active");
            $(".user-login .icon-user").attr("title", "Prijavi se");
        }

    });
}


var Checkout = function (container, type) {
    this.initialize();

    var checkoutValue = $(".checkout-summary-placeholder").data('price');
    var cartContents = [];
    $(".order-products-list .product").each(function () {
        cartContents.push({
            'item_id': $(this).data("productcode"),
            'item_name': $(this).data("title"),
            'discount': $(this).data("discount"),
            'price': $(this).data("price"),
            'quantity': $(this).data("quantity")
        });
    });
};
Checkout.prototype = {

    initialize: function () {
        var self = this;
        if ($("#account-checkbox").is(':checked')) {
            $(".form-password").show().find('input').prop('required', true);
        }

        $("#account-checkbox").on('click', function () {
            if ($(this).is(':checked')) {
                $(".form-password").show().find('input').prop('required', true);
            } else {
                $(".form-password").hide().find('input').prop('required', false);
            }
        });

        $(".delivery-address").find('input').prop('required', false);
        $("#delivery-checkbox").on('click', function () {
            if ($(this).is(':checked')) {
                $(".delivery-address").show().find('input').prop('required', true);
            } else {
                $(".delivery-address").hide().find('input').prop('required', false);
            }
        });

        $(".address-card").on('click', function () {
            $(".address-card.active.selected").removeClass(['active', 'selected']);

            $(this).addClass(['active', 'selected']);

            var address = $(this).data('address');

            $(".delivery-address input[name=delivery_address_id]").val(address.id);

            Object.keys(address).forEach(function (key) {
                $(".delivery-address input[name=delivery_" + key + "]").val(address[key]);
            });
        });

        $("#billing_country_id").on('change', function () {
            if ($("#delivery-checkbox").is(':checked')) {
                return;
            }
            self.updateAvailableCheckoutTypes();
        });

        $("#delivery_country_id").on('change', function () {
            if (!$("#delivery-checkbox").is(':checked')) {
                return;
            }
            self.updateAvailableCheckoutTypes();
        });


        $("#billing_country_id").on("change", function () {



            if ($("#delivery-checkbox").is(":checked")) {



                self.updateAvailableCheckoutTypes();



                return;



            }



            self.updateAvailableCheckoutTypes();



        });



        $("#delivery_country_id").on("change", function () {



            if (!$("#delivery-checkbox").is(":checked")) {



                return;



            }



            self.updateAvailableCheckoutTypes();



        });



        $("#delivery-checkbox").on("change", function () {



            self.updateAvailableCheckoutTypes();



        });



        $("#delivery input, #payment input").on('change', function () {
            self.updateAvailableCheckoutTypes();
        });

        //disable unwanted delivery and payment types
        $("#deliveryTypeAccordion .deliveryType-delivery-basic").hide();
        $("#deliveryTypeAccordion .deliveryType-delivery-conf").hide();
        $("#paymentTypeAccordion .paymentType-cash-on-delivery").hide();

        var configuratorArray = [];
        for (var a in localStorage) {
            if (!localStorage.hasOwnProperty(a)) continue;
            if (!a.includes('-drawers') && !a.includes('-doors') && !a.includes('-combination')) continue;

            configuratorArray.push(JSON.parse(localStorage[a]));
        }
        if (configuratorArray.length > 0) {
            $("#configuratorItems").val(JSON.stringify(configuratorArray));
            $("#deliveryTypeAccordion .deliveryType-delivery-basic").show();
            $("#paymentTypeAccordion .paymentType-payment-preform input").prop("checked", true);
        } else {
            $("#deliveryTypeAccordion .deliveryType-delivery-conf").show();
            $("#paymentTypeAccordion .paymentType-payment-after-delivery").show();
            $("#paymentTypeAccordion .paymentType-cash-on-delivery").show();
            $("#paymentTypeAccordion .paymentType-payment-after-delivery input").prop("checked", true);
        }
        $("#deliveryTypeAccordion .deliveryType-pickup input").prop("checked", true);

        self.getConfiguratorItems();

        self.updateAvailableCheckoutTypes();

        if ($("#delivery-checkbox").is(':checked')) {
            $(".delivery-address").show().find('input').prop('required', true);
        }
    },
    changeDeliveryCountry: function () {
        var country = $("#billing_country_id");
        if ($("#delivery-checkbox").is(':checked')) {
            country = $("#delivery_country_id");
        }
        var countryId = country.val();

        this.saveDeliveryChoice(
            $("input[name=payment_type_id]:checked").val(),
            $("input[name=delivery_type_id]:checked").val(),
            countryId
        );
    },
    paymentCountryId: function () {

        return $("#billing_country_id").val() || $("select[name=billing_country_id]").val() || $("input[name=billing_country_id]").val() || $("input[name=country_id]").val();

    },

    deliveryCountryId: function () {

        if ($("#delivery-checkbox").is(":checked") && $("#delivery_country_id").length > 0) {

            return $("#delivery_country_id").val();

        }

        return this.paymentCountryId();

    },

    countryIds: function (element) {

        try {

            return JSON.parse(element.attr("data-country-ids") || "[]");

        } catch (e) {

            return [];

        }

    },

    filterCheckoutTypes: function (name, countryId) {

        var self = this;

        var selectedAvailable = false;

        var firstAvailable = null;
        var availableCount = 0;

        $("input[name=" + name + "]").each(function () {

            var input = $(this);

            var wrapper = input.closest(".form-check");

            var countryIds = self.countryIds(wrapper);

            var available = !countryId || countryIds.length === 0 || countryIds.indexOf(countryId) !== -1;

            if (input.data("base-disabled") === undefined) {

                input.data("base-disabled", input.is(":disabled"));

            }

            input.prop("disabled", input.data("base-disabled") || !available);

            wrapper.toggleClass("country-unavailable", !available);

            if (input.is(":checked") && !input.is(":disabled")) {

                selectedAvailable = true;

            }

            if (input.is(":checked") && input.is(":disabled")) {

                input.prop("checked", false);

            }

            if (!input.is(":disabled")) {
                availableCount++;
            }

            if (!input.is(":disabled") && firstAvailable === null) {

                firstAvailable = input;

            }

        });

        if (!selectedAvailable && firstAvailable !== null) {

            firstAvailable.prop("checked", true);

        }

        return availableCount;

    },

    toggleDeliveryAvailability: function (hasDeliveryOptions) {
    var accordion = $("#deliveryTypeAccordion");
    var message = accordion.siblings(".delivery-country-unavailable-message");

    accordion.show();
    message.toggle(!hasDeliveryOptions);

    if (!hasDeliveryOptions) {
      $("input[name=delivery_type_id]:checked").prop("checked", false);
    }

    $("button[type=submit], input[type=submit]").each(function () {
      var submit = $(this);
      if (submit.data("base-disabled") === undefined) {
        submit.data("base-disabled", submit.is(":disabled"));
      }
      submit.prop("disabled", submit.data("base-disabled") || !hasDeliveryOptions);
      submit.toggleClass("disabled", !hasDeliveryOptions);
    });
  },
  updateAvailableCheckoutTypes: function () {

        this.filterCheckoutTypes("payment_type_id", this.paymentCountryId());

        var deliveryAvailableCount = this.filterCheckoutTypes("delivery_type_id", this.deliveryCountryId());
        this.toggleDeliveryAvailability(deliveryAvailableCount > 0);

        this.saveDeliveryChoice(

            $("input[name=payment_type_id]:checked").val(),

            $("input[name=delivery_type_id]:checked").val() || $("input[name=delivery_type_id]").val()

        );

    },

    saveDeliveryChoice: function (payment, delivery) {
        var paymentCountry = this.paymentCountryId();
        var deliveryCountry = this.deliveryCountryId();
        var self = this;
        $.post('/cart/checkout-delivery', {
            payment_type_id: payment != null ? payment : null,
            delivery_type_id: delivery != null ? delivery : null,
            country_id: deliveryCountry != null ? deliveryCountry : null,
            payment_country_id: paymentCountry != null ? paymentCountry : null,
            delivery_country_id: deliveryCountry != null ? deliveryCountry : null,
        }, function (html) {
            self.applySummary(html);
            $(".order-summary .personal").hide();
            if ($("#deliveryTypeAccordion .deliveryType-pickup input").is(":checked")) {
                $(".order-summary .personal").show();
            }

            if ($("#deliveryTypeAccordion .deliveryType-pickup input").is(":checked")) {
                if ($("#delivery-checkbox").is(':checked')) {
                    $(".delivery-address").show().find('input').prop('required', false);
                }

                $(".different-address-delivery").hide();
                $(".delivery-address").hide();
            } else {
                if ($("#delivery-checkbox").is(':checked')) {
                    $(".delivery-address").show().find('input').prop('required', true);
                } else {
                    $(".delivery-address").hide();
                }
                $(".different-address-delivery").show();
                //$(".delivery-address").show();
            }
        });
    },
    applySummary: function (html) {
        var self = this;
        $(".checkout-summary-placeholder").html(html);

        if (!self.executed) {
            self.executed = true;
            var contentIds = [];
            var contents = [];
            $("#order-details .product").each(function () {
                contentIds.push($(this).data("productcode"));
                contents.push({ 'id': $(this).data("productcode"), 'quantity': $(this).data("quantity") });
            });
        }

        $(".coupon-form").on('submit', function () {
            var code = $("#discount-code").val();

            $.post('/cart/checkout-coupon', { code: code }, function (html) {
                self.applySummary(html);
            });

            return false;
        });

        $(".coupon-remove").on('click', function () {

            $.get('/cart/checkout-coupon-remove', function (html) {
                self.applySummary(html);
            });

            return false;
        });
    },
    getConfiguratorItems: function () {
        var configuratorArray = [];
        for (var a in localStorage) {
            if (!localStorage.hasOwnProperty(a)) continue;
            if (!a.includes('-drawers') && !a.includes('-doors') && !a.includes('-combination')) continue;

            configuratorArray.push(JSON.parse(localStorage[a]));
        }
        $.post('/cart/configurator-components', {
            items: configuratorArray,
            view: 'checkout'
        }).done(function (html) {
            $('.configurator-items').html(html);
            $(".list-loader").hide();
        });
    }
};

if ($("#checkout").length > 0) {
    new Checkout();
}

var companyCheckbox = $(".personal").find("#company-checkbox");
var companyCont = $(".personal").find("#company");
companyCheckbox.on("click", function () {
    $(companyCont).toggleClass("show");
    var companyAddFields = $(companyCont).find("input[type=text]");

    if ($(this).is(':checked')) {
        $(companyAddFields).each(function (key, field) {
            $(field).prop('required', true);
        })
    } else {
        $(companyAddFields).each(function (key, field) {
            $(field).prop('required', false);
        })
    }
});




setTimeout(function () {
    if (companyCheckbox.is(":checked")) {
        $(companyCont).addClass("show");
    }
}, 500);
